<template>
  <div class="salaryContainer">
    <!-- <div class="circle"></div> -->
    <div class="salary">
      <div v-if="eyeFlag" class="salary_left">
        <p class="p">{{ salary.actual_salary ? reality : "暂无数据" | formatCurrency }}</p>
        <img src="@/assets/img/eyeShow.png" alt="" @click="eyeChangeM(false)">
      </div>
      <div v-else class="salary_left">
        <p class="p">****</p>
        <img src="@/assets/img/eyeHide.png" alt="" @click="eyeChangeM(true)">
      </div>
      <p @click="show = !show">{{ currentDate | formatDate }}</p>
    </div>
    <van-popup v-model="show" position="bottom" class="pick" round>
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :formatter="formatter"
        :max-date="maxDate"
        :min-date="minDate"
        @confirm="confirmMonth"
        @cancel="show = false"
      />
    </van-popup>

    <p class="tip">本月实发合计</p>
    <!-- <div class="salary-info px-2">
      <div class="item">
        <p>869.44</p>
        <p>个人社保</p>
      </div>
      <div class="item">
        <p>1,500.00</p>
        <p>个人公积金</p>
      </div>
      <div class="item">
        <p>70.00</p>
        <p>个人所得税</p>
      </div>
      <div class="item">
        <p>69.00</p>
        <p>其他扣款</p>
      </div>
    </div> -->
    <div class="salary-detail">
      <div class="item" :class="{ showMore: contorl[0] }">
        <div class="label total" @click="showDetail(0)">
          <span class="icon1">应发工资</span>
          <p v-if="eyeFlag">{{ salary.payable | formatCurrency }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.base_salary)">
          <span>基本工资</span>
          <p v-if="eyeFlag">{{ salary.base_salary }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.performance_award)">
          <span>绩效奖金</span>
          <p v-if="eyeFlag">{{ salary.performance_award }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.percentage)">
          <span>提成</span>
          <p v-if="eyeFlag">{{ salary.percentage }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.award)">
          <span>奖金</span>
          <p v-if="eyeFlag">{{ salary.award }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.ot)">
          <span>加班费</span>
          <p v-if="eyeFlag">{{ salary.ot }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.encourage)">
          <span>正负激励</span>
          <p v-if="eyeFlag">{{ salary.encourage }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.subsidy)">
          <span>岗位津贴</span>
          <p v-if="eyeFlag">{{ salary.subsidy }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.workage)">
          <span>工龄补贴</span>
          <p v-if="eyeFlag">{{ salary.workage }}</p>
          <p v-else>****</p>
        </div>

        <div class="label" v-if="Number(salary.meal_allowance)">
          <span>餐费补贴</span>
          <p v-if="eyeFlag">{{ salary.meal_allowance }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.communication)">
          <span>通讯补贴</span>
          <p v-if="eyeFlag">{{ salary.communication }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.transport)">
          <span>交通补贴</span>
          <p v-if="eyeFlag">{{ salary.transport }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.accommodation)">
          <span>住宿补贴</span>
          <p v-if="eyeFlag">{{ salary.accommodation }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.dutyall)">
          <span>全勤奖</span>
          <p v-if="eyeFlag">{{ salary.dutyall }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.attendance_deduction)">
          <span>考勤扣款</span>
          <p v-if="eyeFlag" class="negative">-{{ salary.attendance_deduction }}</p>
          <p v-else class="negative">****</p>
        </div>

        <div class="label" v-if="Number(salary.piece)">
          <span>计件工资 </span>
          <p v-if="eyeFlag">{{ salary.piece }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.abnormal)">
          <span>工时异常补贴 </span>
          <p v-if="eyeFlag">{{ salary.abnormal }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.expression)">
          <span>表现奖 </span>
          <p v-if="eyeFlag">{{ salary.expression }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.night)">
          <span>夜班补贴 </span>
          <p v-if="eyeFlag">{{ salary.night }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.dust)">
          <span> 粉尘补贴 </span>
          <p v-if="eyeFlag">{{ salary.dust }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.hot)">
          <span> 高温补贴 </span>
          <p v-if="eyeFlag">{{ salary.hot }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.special)">
          <span> 特殊津贴 </span>
          <p v-if="eyeFlag">{{ salary.special }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.worktype)">
          <span> 工种补贴 </span>
          <p v-if="eyeFlag">{{ salary.worktype }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.base_wage)">
          <span> 保底工资 </span>
          <p v-if="eyeFlag">{{ salary.base_wage }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.overfulfil)">
          <span> 超产奖 </span>
          <p v-if="eyeFlag">{{ salary.overfulfil }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.labor)">
          <span> 劳保费 </span>
          <p v-if="eyeFlag">{{ salary.labor }}</p>
          <p v-else>****</p>
        </div>
        <div class="label" v-if="Number(salary.other)">
          <span>其他补贴</span>
          <p v-if="eyeFlag">{{ salary.other }}</p>
          <p v-else>****</p>
        </div>
      </div>
      <div class="item" :class="{ showMore: contorl[1] }">
        <div class="label total" @click="showDetail(1)">
          <span class="icon2">代缴代扣</span>
          <p v-if="eyeFlag" class="negative">
            <!-- - -->
            {{ salary.TOO | formatCurrency }}
          </p>
          <p v-else class="negative">****</p>
        </div>
        <div class="label" v-if="salary.insurance">
          <span>个人社保</span>
          <p v-if="eyeFlag" class="negative">{{ salary.insurance }}</p>
          <p v-else class="negative">****</p>
        </div>
        <div class="label" v-if="salary.accumulation">
          <span>个人公积金</span>
          <p v-if="eyeFlag" class="negative">{{ salary.accumulation }}</p>
          <p v-else class="negative">****</p>
        </div>
        <div class="label" v-if="salary.taxed_accumulation">
          <span>税后公积金</span>
          <p v-if="eyeFlag" class="negative">{{ salary.taxed_accumulation }}</p>
          <p v-else class="negative">****</p>
        </div>
        <div class="label" v-if="salary.tax">
          <span>个税</span>
          <p v-if="eyeFlag" class="negative">{{ salary.tax }}</p>
          <p v-else class="negative">****</p>
        </div>
      </div>
      <!-- <div class="item">
        <div class="label total" @click="jumpSocialSecurity">
          <span class="icon2">五险一金</span>
          <p v-if="eyeFlag" class="negative">
            {{ salary.TOO | formatCurrency }}
          </p>
          <p v-else class="negative">****</p>
        </div>
      </div> -->
      <div class="item" :class="{ showMore: contorl[2] }">
        <div class="label total" @click="showDetail(2)">
          <span class="icon3">其他</span>
          <p
            v-if="eyeFlag"
            :class="{
              negative:
                salary.taxoffset ||
                salary.rent ||
                salary.lend ||
                salary.other_deduction,
            }"
          >
            {{
              salary.taxoffset ||
              salary.rent ||
              salary.lend ||
              salary.other_deduction
                ? ""
                : ""
            }}
            {{ salary.POO | formatCurrency }}
          </p>
          <p v-else class="negative">****</p>
        </div>
        <div class="label" v-if="salary.taxoffset">
          <span>个税补差</span>
          <p v-if="eyeFlag" class="negative">{{ salary.taxoffset }}</p>
          <p v-else class="negative">****</p>
        </div>
        <div class="label" v-if="salary.rent">
          <span>水电费房租</span>
          <p v-if="eyeFlag" class="negative">{{ salary.rent }}</p>
          <p v-else class="negative">****</p>
        </div>
        <div class="label" v-if="salary.lend">
          <span>借款</span>
          <p v-if="eyeFlag" class="negative">{{ salary.lend }}</p>
          <p v-else class="negative">****</p>
        </div>
        <div class="label" v-if="salary.other_deduction">
          <span>其他扣款</span>
          <p v-if="eyeFlag" class="negative">{{ salary.other_deduction }}</p>
          <p v-else class="negative">****</p>
        </div>
      </div>
      <!-- <div class="item" :class="{ showMore: contorl[3] }">
        <div class="label total" @click="showDetail(3)">
          <span class="icon4">个税</span>
          <p>40.00</p>
        </div>
      </div> -->
      <div class="item showMore">
        <div class="label total">
          <span class="icon5">备注</span>
        </div>
        <div class="desc py-2 px-3">
          <p>
            1、员工薪酬为公司保密信息，员工之间不得泄漏、询问、截图转发薪酬信息，一经发现，将按照公司规章制度严肃处理。
          </p>
          <p>
            2、请及时核对当月薪资数据，如有异议，请于发放工资后十个工作日内，联系对应HR处理。
          </p>
        </div>
        <!-- <div class="footer">
          <img @click="setDialog" src="../../assets/notice.png" alt="" />
        </div> -->
      </div>
    </div>
    <div class="showTips wow fadeIn" @click="showTip = true">
      <img src="@/assets/salary/question.png" alt="" />
    </div>
    <!-- 年终奖 -->
    <div v-if="hadBonus&&bonus.real_total!='0.00'" class="showTips rewardTip" @click="rewardTip = true">
      <img src="@/assets/salary/reward/tip.png" alt="" />
    </div>
    <!-- <div v-if="showSend" class="showTips showSend" @click="sendInfo">
      <img src="@/assets/salary/send.png" alt="" />
    </div> -->
    <div class="footer showTips">
      <img
        @click="setDialog"
        v-if="infoSalary"
        src="@/assets/notice2.svg"
        alt=""
      />
    </div>
    <van-dialog v-model="showTip" :showConfirmButton="false">
      <div class="dialog-content">
        <div>
          <p class="title">
            请核对本月工资数据，若有异议，须在工资发放后<span class="bolder"
              >10个工作日内</span
            >联系对应人员：
          </p>
          <!-- <p>
            总部职能/全国销售中心/工程赋能中心/五金流通事业部&门店赋能中心&成品供应中心：<br />李静珊（<span>jingshan.li1@nvc-lighting.com</span>）
          </p> -->
          <p>
            总部职能/全国销售中心/工程赋能中心/五金流通事业部&门店赋能中心&成品供应中心：<br />李静珊（<span>jingshan.li1@nvc-lighting.com</span>）
          </p>
          <!-- <p>
            门店赋能中心&成品供应中心：<br />李静珊（<span>jingshan.li1@nvc-lighting.com</span>）
          </p> -->
          <p>
            制造供应中心：<br />董倩楠（<span>qiannan.dong@nvc-lighting.com</span>）
          </p>
          <p>
            万州工厂：<br />彭长菊（<span>changju.peng@nvc-lighting.com</span>）
          </p>
        </div>
        <span @click="showTip = false"></span>
      </div>
    </van-dialog>
    <van-dialog
      id="chatRecord"
      v-model="showDia"
      class="dialog"
      :show-confirm-button="false"
    >
      <div class="diaTop">
        <div class="diaImg">
          <img src="../../assets/quxiao.png" alt="" @click="showDia = false" />
        </div>
        <div class="diaTit" v-if="info.belongType === '1'">薪酬调整通知</div>
        <div
          class="diaTit"
          v-else-if="info.belongType === '2' && info.bonusType === '1'"
        >
          知识产权激励通知
        </div>
        <div
          class="diaTit"
          v-else-if="info.belongType === '2' && info.bonusType === '2'"
        >
          荣誉激励通知
        </div>
        <div
          class="diaTit"
          v-else-if="
            (info.belongType === '2' && info.bonusType === '3') ||
            info.bonusType === ''
          "
        >
          奖金激励通知
        </div>
      </div>
      <div class="diaCon">
        <div class="diaConTit">
          <span>{{ info.name ? info.name : "暂无" }}</span
          >先生/女士
        </div>
        <div v-if="info.belongType === '1'">
          <div class="box">
            现根据公司业务发展需要及您个人的业绩表现，经公司评估决定对您进行以下薪酬调整，具体如下:
          </div>
          <div class="box">
            您的职位:<span class="orange">{{
              info.position ? info.position : "暂无"
            }}</span
            >,
          </div>
          <div class="box">
            职级:<span class="orange">{{ info.rank ? info.rank : "暂无" }}</span
            >。
          </div>
          <div class="box">
            您的税前标准年薪：<span class="orange">{{
              info.standardsalary ? info.standardsalary : "暂无"
            }}</span
            >元（RMB）。 其中，税前月度工资标准：<span class="orange">{{
              info.basepay1 ? info.basepay1 : "暂无"
            }}</span
            >元（RMB）， 月度岗位津贴：<span class="orange">{{
              info.basepay19
            }}</span
            >元（RMB）， 年度固薪：<span class="orange">{{
              info.fixedsalary ? info.fixedsalary : "暂无"
            }}</span
            >元（RMB）， 税前年度目标绩效奖金：<span class="orange">{{
              info.basepay5 ? info.basepay5 : "暂无"
            }}</span>
            元（RMB）。
          </div>
          <div class="box">
            其中，岗位津贴与任职岗位的特殊性有关，若您的岗位发生变化，自变化之日起，公司有权调整或者取消特殊岗位的津贴；年度目标绩效奖金将根据公司组织绩效、
            事业部中心组织绩效、个人绩效的完成情况，经评估后浮动发放，具体核算与发放以公司的奖金政策为准。以上调整从2022年3月1日开始生效。
          </div>
        </div>
        <div v-else-if="info.belongType === '2' && info.bonusType === '2'">
          <div class="box">
            根据公司《荣誉体系管理办法》相关规定，公司鼓励员工的积极行为和优秀表现，并对取得的成果给予鼓励和认可。
          </div>
          <div class="box">
            恭喜您在{{
              info.newYear ? info.newYear : "暂无"
            }}表现优秀，成绩突出，荣获荣誉激励表彰，给予您奖励如下：
          </div>
          <div class="box">
            奖金:人民币<span class="orange">{{
              info.bonusNum ? info.bonusNum : "暂无"
            }}</span
            >元（税前）。
          </div>
          <div class="box">
            兑现时间:随{{ info.statedate ? info.statedate : "暂无" }}工资发放。
          </div>
          <div class="box">
            特别提示：公司的薪酬信息是保密的，任何员工都不得公开或私下通过直接或间接的方式打听、攀比、议论或公开自己（或他人）的薪酬数据。掌握此信息的员工，不得以任何方式泄露。任何违反的行为
            ,将会受到解除劳动合同的纪律处分。
          </div>
        </div>
        <div v-else>
          <div class="box">
            根据公司《知识产权激励办法》，鼓励员工针对公司实际情况，开发申报各类专利、
            软件著作权，发表科研论文，参与国际、国内及照明行业内具有外部影响力的奖项评定，
            提升公司在行业内的专业影响力。根据您参与的项目贡献，给予您奖励如下:
          </div>
          <div class="box">
            项目奖金:人民币<span class="orange">{{
              info.bonusNum ? info.bonusNum : "暂无"
            }}</span
            >元（税前）。
          </div>
          <div class="box">
            兑现时间:随{{ info.statedate ? info.statedate : "暂无" }}工资发放。
          </div>
        </div>
        <div class="box">
          希望您再接再厉，继续为公司做出贡献，与公司共同成长！
        </div>
        <div class="boxFoo">人力行政中心</div>
        <div class="boxFoo">
          {{ info.changedate ? info.changedate : "暂无" }}
        </div>
        <button
          @click="confirmUpper"
          class="confirmBtn"
          v-if="(infoIndex > 0 || infoIndex === -1) && (listIndex === -1 && infoList.length>1)"
        >
          上一条
        </button>
        <button @click="confirmOk" class="confirmBtn">
          {{ infoIndex > 0 ? "下一条" : "确认" }}
        </button>
      </div>
    </van-dialog>
    <reward
      :show="rewardTip"
      :bonus="bonus"
      @closed="rewardTip = !rewardTip"
    ></reward>
  </div>
</template>

<script>
import { removeWatermark, setWaterMark } from "@/assets/js/watermark";
import reward from "@/components/salary/reward.vue";
import utils from "@/assets/js/utils.js";
import api from "@/apis";
import moment from "moment";
import { getToken } from "@/utils/cookie";

export default {
  components: { reward },
  data() {
    return {
      eyeFlag: false,
      showDia: false,
      showSend: false,
      // 推送
      hadBonus: false,
      infoSalary: false,
      bonus: {},
      show: false,
      showTip: false,
      rewardTip: false,
      contorl: [false, false, false, false],
      currentDate: new Date(),
      hadMonth: "",
      maxDate: new Date(),
      minDate: new Date("2000/01/01"),
      timeInterval: null,
      salaryInfo: null,
      salary: {},
      month: "",
      reality: 0,
      formatSpeed: 100,
      isWxwork: true,
      info: {},
      infoIndex: 0,
      infoList: [],
      listIndex: 0,
      empNo: '',
      
    };
  },
  created() {
    if (this.isWxwork) {
      this.maxDate.setMonth(this.maxDate.getMonth() - 1);
      this.currentDate.setMonth(this.currentDate.getMonth() - 1);
      // this.month = moment(this.maxDate).format("YYYY-MM");
      this.getSalary();
      this.getBonus();
      this.sendAuth();
      this.getPayroll();
      this.empNo = getToken()
      return;
    }
    // this.toLogin();
    this.salaryInfo = JSON.parse(localStorage.getItem("salaryInfo"));
    if (this.salaryInfo) {
      this.mark =
        this.salaryInfo.title +
        this.salaryInfo.mobileNo.substring(
          this.salaryInfo.mobileNo.length - 4,
          this.salaryInfo.mobileNo.length
        );
      this.maxDate.setMonth(this.maxDate.getMonth() - 1);
      this.currentDate.setMonth(this.currentDate.getMonth() - 1);
      this.getSalary();
      this.getBonus();
      this.sendAuth();
      this.getPayroll();
    }
    // else {
    //   this.$router.push("/login");
    // }
  },
  mounted() {
    if (!this.isWxwork) setWaterMark(this.mark);
  },
  filters: {
    // 格式化时间
    formatDate(val) {
      if (val === "") {
        return;
      }
      return utils.formatDate(val.getTime() / 1000, "yyyy年MM月");
    },
    formatCurrency(num) {
      if (num) {
        //将num中的$,去掉，将num变成一个纯粹的数据格式字符串
        num = num.toString().replace("$", "");
        //如果num不是数字，则将num置0，并返回
        if ("" == num || isNaN(num)) {
          return num;
        }
        //如果num是负数，则获取她的符号
        var sign = num.indexOf("-") > 0 ? "-" : "";
        //如果存在小数点，则获取数字的小数部分
        var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : "";
        cents = cents.length > 1 ? cents : ""; //注意：这里如果是使用change方法不断的调用，小数是输入不了的
        //获取数字的整数数部分
        num = num.indexOf(".") > 0 ? num.substring(0, num.indexOf(".")) : num;
        //如果没有小数点，整数部分不能以0开头
        if ("" == cents) {
          if (num.length > 1 && "0" == num.substr(0, 1)) {
            return num;
          }
        }
        //如果有小数点，且整数的部分的长度大于1，则整数部分不能以0开头
        else {
          if (num.length > 1 && "0" == num.substr(0, 1)) {
            return num;
          }
        }
        //针对整数部分进行格式化处理，这是此方法的核心，也是稍难理解的一个地方，逆向的来思考或者采用简单的事例来实现就容易多了
        /*
                  也可以这样想象，现在有一串数字字符串在你面前，如果让你给他家千分位的逗号的话，你是怎么来思考和操作的?
                  字符串长度为0/1/2/3时都不用添加
                  字符串长度大于3的时候，从右往左数，有三位字符就加一个逗号，然后继续往前数，直到不到往前数少于三位字符为止
                 */
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
          num =
            num.substring(0, num.length - (4 * i + 3)) +
            "," +
            num.substring(num.length - (4 * i + 3));
        }
        //将数据（符号、整数部分、小数部分）整体组合返回
        return sign + num + cents;
      }
    },
  },

  methods: {
    //跳转社保查询页面
    // jumpSocialSecurity() {
    //    this.$router.push(`/mobile/social-security?month=${moment(this.currentDate).format('YYYY-MM')}`) 
    // },
    //点击睁眼&闭眼
    eyeChangeM(flag) {
      this.eyeFlag = flag
    },
    //获取工资列表
    getPayroll() {
      const thisDate = new Date();
      let obj = {
        empNo: getToken(),
        operateType: "3",
        searchDate: moment(thisDate).format("YYYY-MM"),
        operateTime: moment(thisDate).format("YYYY-MM-DD HH:mm:ss"),
        searchTyppe: "",
        pageNum: 1,
        pageSize: 10,
        operateNo: getToken(),
      };
      api
        .getSelectSalaryList({ ...obj })
        .then((data) => {
          console.log(data.data.list[0], "020020202020");
          if (!data.data) return;
          // if (data.data.list[0].empReadState ==='1') return;
          // if (data.data.list[0].empReadState !=='1') this.showDia=true;
          this.infoList = data.data.list;
          this.infoList.forEach((item) => {
            if (item.empReadState !== "1") {
              this.showDia = true;
            }
          });
          this.infoSalary = true;
          this.setInfo(0);
        })
        .catch(() => {
          this.infoSalary = false;
        });
      // api.getSelectBonus({empNo:'10004597',searchDate:'2022-08'}).then((data)=>{
      //   const changedate = moment(data.data.cuEmpchange.changedate).format('YYYY年MM月DD日')
      //   this.info={...data.data.cuEmpchange,changedate}
      // })
    },
    //获取用户信息
    setInfo(index) {
      const changedate = moment(this.infoList[index].hrsendTime).format(
        "YYYY年MM月DD日"
      );
      const statedate = moment(this.infoList[index].regTime).format(
        "YYYY年度MM月"
      );
      const newYear = moment(this.infoList[index].regTime).format("YYYY年");
      this.info = { ...this.infoList[index], changedate, statedate, newYear };
      index++;
      if (index >= this.infoList.length) {
        index = -1;
      }
      this.infoIndex = index;
      this.listIndex = index;
    },
    //确认&下一条
    confirmOk() {
      if (this.infoIndex < 0) {
        this.showDia = false;
        setTimeout(() => {
          this.setInfo(0);
        }, 300);
      } else {
        this.setInfo(this.infoIndex);
        let ele = document.getElementById("chatRecord");
        ele.scrollTop = 0;
      }
    },
    // 上一条
    confirmUpper() {
      let ele = document.getElementById("chatRecord");
      if (this.infoIndex !== -1) {
        this.infoIndex--;
        this.setInfo(this.infoIndex);
        ele.scrollTop = 0;
      } else {
        this.infoIndex = this.infoIndex + this.infoList.length - 1;
        this.setInfo(this.infoIndex);
        ele.scrollTop = 0;
      }
    },
    // 显示弹窗
    setDialog() {
      this.showDia = true;
    },
    // 推送消息
    sendInfo() {
      this.$dialog
        .confirm({
          message: "确定推送消息吗",
        })
        .then(() => {
          // on confirm
          api
            .sendInfo()
            .then(() => {
              this.$notify({
                type: "success",
                message: "推送成功",
              });
            })
            .catch((err) => {
              this.$notify({
                type: "error",
                message: err.msg,
              });
            });
        })
        .catch(() => {
          // on cancel
        });
      return;
    },
    // 获取推送权限
    sendAuth() {
      api.sendAuth().then((res) => {
        this.showSend = res.data == 1 ? true : false;
      });
    },
    // 获取年终奖
    getBonus() {
      api
        .getBonus()
        .then((res) => {
          if (!res.data) return;
          this.hadBonus = true;
          this.bonus = res.data;
          if (this.bonus.is_read == 0 && this.bonus.real_total != '0.00') this.rewardTip = true;
          
        })
        .catch(() => {
          this.hadBonus = false;
        });
    },
    // 数字滚动的效果
    accumulativeMachine() {
      setTimeout(() => {
        this.formatSpeed = Math.floor(Math.random() * (200 - 100)) + 100;
        this.reality += this.formatSpeed;
        if (this.reality >= this.salary.actual_salary) {
          this.reality = this.salary.actual_salary;
          return;
        }
        this.accumulativeMachine();
      }, 20);
    },
    // 获取工资信息
    getSalary() {
      api
        .getSalary({
          month: this.month,
        })
        .then((res) => {
          this.salary = res.data;
          if (this.isWxwork) {
            this.mark =
              this.salary.Title +
              this.salary.MobileNo.substring(
                this.salary.MobileNo.length - 4,
                this.salary.MobileNo.length
              );
            setWaterMark(this.mark);
          }
          // 代缴
          this.salary.TOO = (
            parseFloat(this.salary.insurance) +
            parseFloat(this.salary.accumulation) +
            parseFloat(this.salary.taxed_accumulation) +
            parseFloat(this.salary.tax)
          ).toFixed(2);
          // 其他
          this.salary.POO = (
            parseFloat(this.salary.taxoffset) +
            parseFloat(this.salary.rent) +
            parseFloat(this.salary.lend) +
            parseFloat(this.salary.other_deduction)
          ).toFixed(2);
          this.reality = 0;
          this.accumulativeMachine();
          this.minDate = new Date(res.data.month_list[0]);
          this.currentDate = new Date(res.data.month);
          this.hadMonth = this.currentDate;
          //五险一金
        })
        .catch(() => {
          this.currentDate = this.hadMonth;
          this.salary = "";
          this.$notify({
            type: "error",
            message:
              "当前月份薪资数据暂未公布，HR小姐姐紧急处理中，请耐心等候~",
            color: "#000000",
          });
        });
    },
    // 选择月份
    confirmMonth(e) {
      // this.month = moment(e).format("YYYY-MM")
      // this.month = utils.formatDate(e.getTime() / 1000, "yyyy-MM");
      this.month = utils.formatDate(e.getTime() / 1000, "yyyy-MM");
      this.show = false;
      this.getSalary();
    },
    //格式化时间
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    showDetail(index) {
      this.$set(this.contorl, index, !this.contorl[index]);
    },
  },
  beforeDestroy() {},
  destroyed() {
    removeWatermark();
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020/375;
@font-face {
  font-family: "DINPro";
  src: url(~@/assets/font/DINPro.otf), url(~@/assets/font/DINPro.ttf);
  font-weight: normal;
  font-style: normal;
}
@mixin flex-between($way: row) {
  display: flex;
  flex-direction: $way;
  align-items: center;
  justify-content: space-between;
}
@mixin flex-around($way: row) {
  display: flex;
  flex-direction: $way;
  align-items: center;
  justify-content: space-around;
}
@mixin flex-center($way: row) {
  display: flex;
  flex-direction: $way;
  align-items: center;
  justify-content: center;
}
@keyframes easing {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
}
@media screen and (max-width: 600px) {
  .salaryContainer {
    width: 100%;
  }
  .dialog {
    width: 100% !important;
    .diaTop {
      height: 75px * $zoom;
      .diaTit {
        height: calc(75px * $zoom - 10px * $zoom);
        font-size: 20px * $zoom;
        line-height: calc(75px * $zoom - 50px * $zoom);
      }
    }
  }
}
@media screen and (min-width: 600px) {
  .salaryContainer {
    width: 420px * $zoom;
  }
  .dialog {
    width: 420px * $zoom !important;
    .diaTop {
      height: 115px * $zoom;
      .diaTit {
        height: calc(120px * $zoom - 10px * $zoom);
        font-size: 26px * $zoom;
        line-height: calc(120px * $zoom - 50px * $zoom);
      }
    }
  }
}
.salaryContainer {
  background: url("~@/assets/salary/index-bg.png") no-repeat;
  background-size: 100% auto;
  @include container();
  position: relative;
  // .circle {
  //   position: absolute;
  //   width: 236px;
  //   height: 236px;
  //   background: #29a375;
  //   top: 180px;
  //   left: 300px;
  //   border-radius: 50%;
  //   opacity: 0.5;
  //   z-index: 1;

  //   animation: easing 4s infinite linear;
  // }
  .salary {
    position: relative;
    z-index: 2;
    padding: 100px 30px 20px 60px;
    @include flex-between();
    .salary_left {
      display: flex;
      align-items: center;
      .p {
        font-size: 72px;
        font-family: DINPro;
        font-weight: bold;
        color: #ffffff;
        text-shadow: 0px 4px 5px rgba(1, 137, 86, 0.17);
      }
      img {
        width: 36px;
        height: 36px;
        margin-left: 24px;
      }
    }
    & > p:nth-child(2) {
      cursor: pointer;
      width: 192px;
      height: 52px;
      background: #076f47;
      border-radius: 26px;
      font-size: 22px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 52px;
      text-align: center;
      padding-right: 24px;
      position: relative;
      &::after {
        content: "";
        display: block;
        width: 20px;
        height: 16px;
        background: url("~@/assets/salary/arrow.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .tip {
    position: relative;
    z-index: 2;
    padding-left: 60px;
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #ffffff;
  }
  .salary-info {
    position: relative;
    z-index: 2;
    margin: 50px auto 0;
    width: 702px;
    height: 160px;
    background: #ffffff;
    box-shadow: 0px 7px 9px 0px rgba(209, 209, 209, 0.2);
    border-radius: 15px;
    @include flex-around();
    .item {
      & > p:nth-child(1) {
        font-size: 30px;
        font-family: DINPro;
        font-weight: bold;
        color: #000000;
      }
      & > p:nth-child(2) {
        margin-top: 10px;
        font-size: 24px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #999999;
      }
    }
  }
  .salary-detail {
    margin-top: 80px;
    position: relative;
    z-index: 1;
    .item {
      width: 702px;
      margin: 0 auto;
      margin-bottom: 16px;
      background: #ffffff;
      box-shadow: 0px 7px 9px 0px rgba(209, 209, 209, 0.3);
      border-radius: 15px;
      overflow: hidden;
      max-height: 100px;
      transition: all 0.4s linear;

      .label {
        @include flex-between();
        padding: 0 30px;
        height: 80px;
        background: rgba(255, 255, 255, 0.5);

        & > span {
          font-size: 28px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          color: #999999;
        }
        & > p {
          font-size: 28px;
          font-family: DINPro;
          font-weight: bold;
          color: #020202;
        }
        & > .negative {
          color: #c9393e;
        }
      }
      .label:nth-child(2n) {
        background: rgba(250, 251, 253, 0.5);
      }
      .desc {
        font-size: 26px;
        font-family: Source Han Sans SC;
        color: #999999;
        line-height: 40px;
        & > p {
          margin-bottom: 20px;
          & > span {
            color: #018755;
          }
        }
      }
      .total {
        height: 100px;
        cursor: pointer;
        & > span {
          font-size: 30px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          color: #020202;
          padding-left: 60px;
          position: relative;
          &::after {
            content: "";
            display: block;
            position: absolute;
            width: 44px;
            height: 44px;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
          }
        }
        & > p {
          font-size: 36px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #020202;
        }
        & > .icon1 {
          &::after {
            background: url("~@/assets/salary/icon1.png") no-repeat;
            background-size: contain;
          }
        }
        & > .icon2 {
          &::after {
            background: url("~@/assets/salary/icon2.png") no-repeat;
            background-size: contain;
          }
        }
        & > .icon3 {
          &::after {
            background: url("~@/assets/salary/icon3.png") no-repeat;
            background-size: contain;
          }
        }
        & > .icon4 {
          &::after {
            background: url("~@/assets/salary/icon4.png") no-repeat;
            background-size: contain;
          }
        }
        & > .icon5 {
          &::after {
            background: url("~@/assets/salary/icon5.png") no-repeat;
            background-size: contain;
          }
        }
      }
    }
    .showMore {
      max-height: none;
    }
  }
  .showTips {
    width: 116px;
    height: 120px;
    position: fixed;
    right: 20px;
    bottom: 210px;
    z-index: 10;
    & > img {
      width: 100%;
      height: 100%;
    }
  }
  .rewardTip {
    width: 130px;
    height: 120px;
    right: 20px;
    bottom: 80px;
    z-index: 10;
  }
  .showSend {
    bottom: 420px;
    z-index: 10;
  }
  .footer {
    bottom: 330px;
    z-index: 10;
  }
  &::v-deep .van-dialog {
    width: 670px;
    background: transparent;
  }
  .dialog-content {
    @include flex-center(column);

    & > div {
      width: 670px;
      padding: 40px 40px;
      background: #ffffff;
      border-radius: 15px;
      & > .title {
        margin-bottom: 30px;
      }
      & > p {
        margin-bottom: 20px;
        font-size: 26px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #020202;
        text-align: justify;
        & > span {
          color: #058655;
        }
        & > .bolder {
          font-weight: bold;
        }
      }
    }
    & > span {
      margin-top: 25px;
      width: 40px;
      height: 40px;
      background: url("~@/assets/selection/close.png") no-repeat;
      background-size: cover;
    }
  }
}
.dialog {
  margin-top: 8vh;
  max-height: 92vh;
  border-radius: 20px * $zoom;
  background: #fff !important;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0px;
    height: 6px;
    background-color: rgba(240, 240, 240, 1);
  }
  ::v-deep .van-button {
    font-size: 16px * $zoom;
  }
  .diaTop {
    width: 100%;
    background: url("~@/assets/diaTop.png") no-repeat;
    background-size: 100%;
    font-size: 24px * $zoom;
    color: #fff;
    position: sticky;
    top: 0;
    background-color: #fff;
    .diaImg {
      display: flex;
      justify-content: flex-end;
      margin-right: 15px * $zoom;
      padding-top: 10px * $zoom;
    }
    .diaTit {
      text-align: center;
    }
  }
  .diaCon {
    padding: 5px * $zoom 15px * $zoom;
    font-size: 14px * $zoom;
    .box {
      margin-top: 3px * $zoom;
      line-height: 23px * $zoom;
      text-indent: 2em;
    }
    .boxFoo {
      margin-top: 10px * $zoom;
      line-height: 22px * $zoom;
      display: flex;
      justify-content: flex-end;
      padding-right: 15px * $zoom;
    }
    .orange {
      color: #ec7043;
      margin: 0 4px * $zoom;
    }
    .diaConTit {
      font-size: 14px * $zoom;
      span {
        font-size: 14px * $zoom;
        color: #ec7043;
        margin-right: 5px * $zoom;
      }
    }
  }
}
.pick {
  ::v-deep .van-picker__toolbar {
    height: 40px * $zoom;
    .van-picker__confirm,
    .van-picker__cancel {
      font-size: 7px * $zoom;
    }
  }
  ::v-deep .van-ellipsis {
    font-size: 20px;
  }
}

.confirmBtn {
  width: 100%;
  height: 100px;
  margin-top: 10px;
  background: none;
  color: #ee0a24;
  font-size: 18pt;
}
</style>
